import { Star } from "@styled-icons/fa-regular/Star";

import { Box } from "rebass";

export function EnqueteStatusStarIcon() {
  return (
    <Box
      sx={{
        color: "#6463636b",
        width: "18px",
      }}
    >
      <Star />
    </Box>
  );
}
